import React from 'react';
import {useDispatch} from 'react-redux';
import {Button, ButtonGroup, Callout, Intent} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {deleteBlock} from '../../../store/actions/blockActions';
import {toggleConnectionDialog} from '../../../store/actions/uiActions';
import {NoResult as NoResult_} from '../../list';
import {useCurrentUser} from '../../../hooks';
import {isAdmin} from '../../../utils/auth';

interface NoDatabaseProps {
  contentId: string;
  showDelete?: boolean;
  onDelete?: (value?: any) => void;
}

export const NoDatabase = ({
  contentId,
  showDelete,
  onDelete,
}: NoDatabaseProps) => {
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  /*
   * Only admins can create a new integration
   */
  const canAddIntegration = isAdmin(currentUser);
  const showActions = (canAddIntegration || showDelete);

  const onClick = () => {
    dispatch(toggleConnectionDialog(true));
  }

  const _onDelete = () => {
    dispatch(deleteBlock(contentId as string, true));

    onDelete && onDelete(contentId as string);
  };

  return (
    <NoResult_
      className="no-database"
      icon={IconNames.DATA_CONNECTION}
      title="No databases found"
      description=""
      action={
        showActions ? (
          <ButtonGroup>
            {
              canAddIntegration && (
                <Button
                  minimal={true}
                  icon={IconNames.PLUS}
                  text="Add Database"
                  onClick={onClick}
                  intent={Intent.PRIMARY}
                  outlined={true}
                />
              )
            }
            {
              showDelete && (
                <>
                  {
                    canAddIntegration && (
                      <Button
                        minimal={true}
                        text=" or "
                        disabled={true}
                        className="fake-button"
                      />
                    )
                  }
                  <Button
                    minimal={true}
                    icon={IconNames.TRASH}
                    text="Remove"
                    onClick={_onDelete}
                    intent={Intent.DANGER}
                    outlined={true}
                  />
                </>
              )
            }
          </ButtonGroup>
        ) : undefined
      }
    />
  );
}

export const NoDatabaseCallout = () => (
  <Callout
    title="No Database Selected"
    icon={IconNames.DATA_CONNECTION}
    intent={Intent.WARNING}
  >
    Please select a database first.
  </Callout>
);

export default NoDatabase;
